import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { api } from '../services/api';

interface CurrencyContextValue {
  baseCurrencyCode: string;
  baseCurrencySymbol: string;
  loading: boolean;
  error: string | null;
}

const CurrencyContext = createContext<CurrencyContextValue>({
  baseCurrencyCode: 'TRY',
  baseCurrencySymbol: '₺',
  loading: true,
  error: null
});

interface CurrencyProviderProps {
  children: ReactNode;
}

export const CurrencyProvider: React.FC<CurrencyProviderProps> = ({ children }) => {
  const [baseCurrencyCode, setBaseCurrencyCode] = useState('TRY');
  const [baseCurrencySymbol, setBaseCurrencySymbol] = useState('₺');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadCurrencies = async () => {
      try {
        setLoading(true);
        setError(null);

        const { data } = await api.get<{ baseCurrencyCode: string; items: Array<{ code: string; symbol: string; isDefault?: boolean }> }>('/currencies');

        if (data?.baseCurrencyCode) {
          setBaseCurrencyCode(data.baseCurrencyCode);
        }

        if (data?.items?.length) {
          const baseCurrency = data.items.find(item => item.code === data.baseCurrencyCode) || data.items.find(item => item.isDefault) || data.items[0];
          if (baseCurrency?.symbol) {
            setBaseCurrencySymbol(baseCurrency.symbol);
          }
        }
      } catch (err) {
        console.error('Base currency load error:', err);
        setError('Para birimi bilgisi alınamadı');
      } finally {
        setLoading(false);
      }
    };

    loadCurrencies();
  }, []);

  return (
    <CurrencyContext.Provider value={{ baseCurrencyCode, baseCurrencySymbol, loading, error }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);








